import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dt-mainCard__content-block" }
const _hoisted_2 = {
  key: 0,
  class: "dt-mainCard__content-block-title"
}
const _hoisted_3 = { class: "dt-mainCard__content-table" }
const _hoisted_4 = { class: "dt-mainCard__content-table-row" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.element.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.element.title), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(row.title), 1 /* TEXT */),
          (row['@type'] === 'text-row-element')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(row.value), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_6))
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}